import type { IframePoolOrder } from '../api';

export const DEFAULT_PEDESTAL_SRC = '/templates/modern/default-piedestal.png';

/** The stand under a revealed card: the pack's own artwork, or the product default. */
export function pedestalSrcFor(
  offer: Pick<IframePoolOrder['poolOffer'], 'pedestalImageUrl'>,
): string {
  return offer.pedestalImageUrl ?? DEFAULT_PEDESTAL_SRC;
}
